import type { BranchDeliverySystemType } from '../enums/BranchDeliverySystemType'
import type { DeliverySystemType } from '../enums/DeliverySystemType'

export class BranchDeliverySettingMiniEntity {
  id?: number
  name?: string | null
  type?: DeliverySystemType
  valueType?: BranchDeliverySystemType
}
